// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__fkhg3","detailsBorder":"styles_detailsBorder__3NKp4"};